var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-info",
    clipPath: "url(#clip0_2310_66691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58173 12.4183 0 8 0C3.58173 0 0 3.58173 0 8C0 12.4183 3.58173 16 8 16ZM6.28571 10.7143C5.89122 10.7143 5.57143 11.0341 5.57143 11.4286C5.57143 11.8231 5.89122 12.1429 6.28571 12.1429H9.71429C10.1088 12.1429 10.4286 11.8231 10.4286 11.4286C10.4286 11.0341 10.1088 10.7143 9.71429 10.7143H8.71429V7.42857C8.71429 7.03408 8.39449 6.71429 8 6.71429H6.85714C6.46265 6.71429 6.14286 7.03408 6.14286 7.42857C6.14286 7.82306 6.46265 8.14286 6.85714 8.14286H7.28571V10.7143H6.28571ZM9.14286 4.57143C9.14286 5.20261 8.63118 5.71429 8 5.71429C7.36882 5.71429 6.85714 5.20261 6.85714 4.57143C6.85714 3.94025 7.36882 3.42857 8 3.42857C8.63118 3.42857 9.14286 3.94025 9.14286 4.57143Z",
    fill: "#0A0A0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2310_66691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnIcon);
export default __webpack_public_path__ + "static/media/warn_icon.35432b8611134c3b2d80a158b5455a73.svg";
export { ForwardRef as ReactComponent };